import { mapActions } from 'pinia'
import { resolveRoute } from '@/router/resolve'
import { useAuthStore } from '@/store/pinia/auth'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        ...mapActions(useAuthStore, [
          'EVALUATE_USER_ACTIONS',
        ]),
        async $evaluateUserActions (triggered = null, { routeName, params } = {}) {
          const meta = routeName
            ? resolveRoute({ name: routeName, params })?.meta
            : this.$route?.meta
          const routeActions = Object.values(meta?.actions || {})
          const routeReqActions = meta?.requiredActions || []
          const actions = triggered || [
            ...routeActions,
            ...(_.isFunction(routeReqActions) ? routeReqActions() : routeReqActions),
          ]

          if (_.$isEmpty(actions)) return
          await this.EVALUATE_USER_ACTIONS({ actions: _.isString(actions) ? [actions] : actions })
        },
      },
    })
  },
}
